import { Card, Group, Text, ThemeIcon } from "@mantine/core";
import {
  IconArrowDownRight,
  IconArrowUpRight,
  IconMinus,
  type TablerIcon,
} from "@tabler/icons-react";
import type { TrendData } from "../../types/admin";

export function StatCard({
  label,
  value,
  icon: Icon,
  trend,
  sub,
}: {
  label: string;
  value: string | number;
  icon?: TablerIcon;
  trend?: TrendData;
  sub?: string;
}) {
  const dir = trend?.direction;
  const trendColor =
    dir === "up" ? "teal" : dir === "down" ? "red" : "gray";
  const TrendIcon =
    dir === "up"
      ? IconArrowUpRight
      : dir === "down"
        ? IconArrowDownRight
        : IconMinus;

  return (
    <Card withBorder padding="lg" radius="md">
      <Group justify="space-between" align="flex-start">
        <Text size="xs" c="dimmed" fw={600} tt="uppercase">
          {label}
        </Text>
        {Icon && (
          <ThemeIcon variant="light" size="lg" radius="md">
            <Icon size={20} />
          </ThemeIcon>
        )}
      </Group>

      <Text fw={700} fz={28} mt="sm" lh={1.1}>
        {value}
      </Text>

      <Group gap="xs" mt="xs">
        {trend && (
          <Text c={trendColor} size="sm" fw={600} component="span">
            <TrendIcon
              size={14}
              style={{ verticalAlign: "middle", marginRight: 2 }}
            />
            {trend.value}
          </Text>
        )}
        {(sub || trend) && (
          <Text c="dimmed" size="xs">
            {sub ?? trend?.period}
          </Text>
        )}
      </Group>
    </Card>
  );
}
